import tw from 'twin.macro'
import { styled } from '@mui/material/styles'

export const FileContainer = styled('div')`
  & {
    & label {
      ${tw`cursor-pointer`}
    }
    & label.is-disabled {
      ${tw`opacity-50 cursor-not-allowed`}
    }
  }
`
export const FileCustom = styled('div')`
  ${tw`py-4 px-6 flex flex-col items-center justify-center bg-white border-dashed border border-gray-200 rounded-xl`}
`
export const FileIcon = styled('i')`
  ${tw`w-10 h-10 flex justify-center items-center text-2xl text-gray-600 bg-gray-100 border-[6px] border-gray-50 rounded-full mb-3`}
`
export const FileError = styled('div')`
  ${tw`text-xs-regular text-red-500 text-center`}
`
export const FileDescription = styled('div')`
  ${tw`text-sm-regular text-gray-600`}
`
export const FileDescriptionLink = styled('span')`
  ${tw`text-sm-semibold text-primary-700`}
`
export const FileLabel = styled('div')`
  ${tw`text-xs-regular text-gray-600 text-center`}
`
export const FileLabelLink = styled('div')`
  ${tw`text-primary-700 text-center`}
`
